import Vue from 'vue'
import VueRouter from 'vue-router'

import AppRoutes from '@/app/router/routes'

Vue.use(VueRouter)

export function createRouter (): VueRouter {
    return new VueRouter({
        mode: 'history',
        linkActiveClass: 'active',
        routes: AppRoutes
    })
}
